export const CHANGE_MODAL_MESSAGE = "CHANGE_MODAL_MESSAGE";


export const CHANGE_MODAL_MESSAGE_ACTION = (
    message?: string | null,
    messageType?: "DEFAULT" | "ERROR" | "SUCCESS",
    acceptHandler?: () => void,
    declineHandler?: () => void
) => {
    return {
        type: CHANGE_MODAL_MESSAGE,
        message: {
            messageType: messageType,
            content: message,
            acceptHandler: acceptHandler,
            declineHandler: declineHandler
        }
    }
};


export default CHANGE_MODAL_MESSAGE_ACTION;
